<!-- 添加活动商品 -->
<template>
    <el-dialog :visible.sync="centerDialogVisible" width="75%" center>
        <div class="title">
            添加参与活动的商品
        </div>
        <div class="selectBox">
            <div class="selectBoxL">
                <el-button style="margin-bottom: 0.1rem;" size="small" icon="el-icon-search" type="primary">搜索</el-button>
                <p>重置</p>
            </div>
            <div class="line"></div>
            <div class="selectBoxR">
                <div class="selectBoxRLineBox">
                    <el-button class="selectBtn" v-for="(item, index) in  typeList" :key="index"> {{ item.name
                    }}</el-button>
                </div>
                <div class="selectBoxRLineBox">
                    <el-button class="selectBtn" v-for="item in  resourceType" :key="item.code"> {{ item.name1
                    }}</el-button>
                </div>
                <el-input style="width: 4rem;" placeholder="输入产品名称、地点等"></el-input>
            </div>
        </div>
        <goodsTable></goodsTable>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="centerDialogVisible = false">确 认</el-button>
            <el-button @click="centerDialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { resourceType } from '@/assets/utils/unit'
import goodsTable from './goodsTable.vue'
export default {
    components: {
        goodsTable
    },
    data() {
        return {
            resourceType,
            centerDialogVisible: false,
            typeList: [{
                name: '全部',
                code: null,
            },
            {
                name: 'FIT产品',
                code: null,
            },
            {
                name: '预算产品',
                code: null,
            },
            {
                name: '专属库存',
                code: null,
            }
            ]
        }
    },
    computed: {},
    watch: {},
    methods: {
        //初始化
        init() {
            this.centerDialogVisible = true
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialog {
    border-radius: 0 !important;
}

/deep/ .el-dialog__header {
    padding: 0 !important;
}

/deep/ .el-dialog__body {
    padding: 0 !important;
}

.title {
    padding-left: 0.24rem;
    height: 0.62rem;
    line-height: 0.62rem;
    background-color: rgba(231, 235, 239, 1);
    color: rgba(219, 78, 26, 1);
    font-size: 0.2rem;
    font-family: SourceHanSansSC-bold;
    margin-bottom: 0.5rem;
}

.selectBox {
    padding: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 0.3rem;

    .selectBoxL {
        display: flex;
        align-items: center;
        flex-direction: column;

        p {
            color: rgba(16, 16, 16, 1);
            font-size: 0.14rem;
            font-family: SourceHanSansSC-regular;
        }
    }

    .line {
        height: 1.8rem;
        width: 1px;
        border-right: 1px solid #C1C3C9;
        margin: 0 0.24rem;
    }

    .selectBoxR {
            .selectBoxRLineBox {
                margin-bottom: 0.2rem;
                .selectBtn {
                width: 1rem;
                background-color: rgba(237, 241, 242, 1);
                text-align: center;
                color: rgba(101, 113, 128, 1);
                font-family: SourceHanSansSC-regular;
                &:nth-last-child(1) {
                    margin-bottom: 0;
                }
            }
        }
    }


}
</style>